import * as Editable from '../../../Data/Editable'
import * as InvoiceAddress from '../../../Entities/InvoiceAddress'
import {invoiceAddressDecoder} from '../../../Entities/InvoiceAddress'
import {InvoiceSubAction} from './InvoiceActions'
import {InvoiceTab} from './InvoiceState'
import {OrderDetailsFeedback} from '../OrderDetailsFeedback'
import {update} from '../../../Data/ObjectHelper'
import * as OrderResource from '../../../Request/OrderResource'
import {decodeHttpResponse} from '../../../Data/Http'
import {FeedbackLoop} from '../../../Data/FeedbackLoop'

export function initInvoice(invoiceAddress: InvoiceAddress.InvoiceAddress): InvoiceTab {
    return {
        invoiceAddress,
        invoiceAddressForm: {
            type: 'Locked',
        },
    }
}

type InvoiceLoop =
    FeedbackLoop<InvoiceTab, OrderDetailsFeedback>

export function invoiceReducer(
    orderId: number,
    action: InvoiceSubAction,
    state: InvoiceTab,
): InvoiceLoop {
    switch (action.type) {
        case 'EditInvoice': {
            return {
                state: update({
                    invoiceAddressForm: {
                        type: 'Pending',
                        value: state.invoiceAddress,
                    }
                }, state),
                feedback: [],
            }
        }
        case 'InvoiceName1Changed':
            return updateInvoiceAddressForm(
                invoiceAddress => update(({
                    invoiceName1: action.value,
                }), invoiceAddress),
                state)
        case 'InvoiceName2Changed':
            return updateInvoiceAddressForm(
                invoiceAddress => update(({
                    invoiceName2: action.value,
                }), invoiceAddress),
                state)
        case 'InvoiceName3Changed':
            return updateInvoiceAddressForm(
                invoiceAddress => update(({
                    invoiceName3: action.value,
                }), invoiceAddress),
                state)
        case 'InvoiceName4Changed':
            return updateInvoiceAddressForm(
                invoiceAddress => update(({
                    invoiceName4: action.value,
                }), invoiceAddress),
                state)
        case 'InvoiceStreetChanged':
            return updateInvoiceAddressForm(
                invoiceAddress => update(({
                    invoiceStreet: action.value,
                }), invoiceAddress),
                state)
        case 'InvoiceHouseNumberChanged':
            return updateInvoiceAddressForm(
                invoiceAddress => update(({
                    invoiceHouseNumber: action.value,
                }), invoiceAddress),
                state)
        case 'InvoiceZipCodeChanged':
            return updateInvoiceAddressForm(
                invoiceAddress => update(({
                    invoiceZipCode: action.value,
                }), invoiceAddress),
                state)
        case 'InvoiceCityChanged':
            return updateInvoiceAddressForm(
                invoiceAddress => update(({
                    invoiceCity: action.value,
                }), invoiceAddress),
                state)
        case 'InvoiceCountryChanged':
            return updateInvoiceAddressForm(
                invoiceAddress => update(({
                    invoiceCountry: action.value,
                }), invoiceAddress),
                state)
        case 'SaveInvoice': {
            const {invoiceAddressForm} = state
            if (invoiceAddressForm.type === 'Pending' || invoiceAddressForm.type === 'Failure') {
                const invoiceAddress = invoiceAddressForm.value
                return {
                    state: update({
                        invoiceAddressForm: {
                            type: 'Loading',
                            value: invoiceAddress,
                        },
                    }, state),
                    feedback: [{
                        type: 'SendRequest',
                        identifier: {
                            type: 'OrderInvoiceAddressPatch',
                        },
                        httpRequest:
                            OrderResource.patchInvoiceAddress(
                                invoiceAddress,
                                orderId,
                            ),
                    }],
                }
            }
            return {state, feedback: []}
        }
        case 'InvoiceAddressPatchResponse': {
            const
                {invoiceAddressForm} = state,
                result =
                    decodeHttpResponse(
                        invoiceAddressDecoder(),
                        action.result)
            if (invoiceAddressForm.type !== 'Locked') {
                return (() => {
                    switch (result.type) {
                        case 'Ok':
                            return {
                                state: update({
                                    invoiceAddress: result.value,
                                    invoiceAddressForm: {
                                        type: 'Locked',
                                    },
                                }, state),
                                effects: [],
                                feedback: [],
                            }
                        case 'Err':
                            return {
                                state: update({
                                    invoiceAddressForm: {
                                        type: 'Failure',
                                        value: invoiceAddressForm.value,
                                        error: result.error,
                                    }
                                }, state),
                                effects: [],
                                feedback: [],
                            }
                    }
                })()
            } else {
                return {state, feedback: []}
            }
        }
        case 'DiscardInvoice':
            return {
                state: update({
                    invoiceAddressForm: {
                        type: 'Locked',
                    }
                }, state),
                feedback: [],
            }
    }
}

function updateInvoiceAddressForm(
    fn: (invoiceAddress: InvoiceAddress.InvoiceAddress) => InvoiceAddress.InvoiceAddress,
    state: InvoiceTab,
): InvoiceLoop {
    return {
        state: update({
            invoiceAddressForm:
                Editable.map(
                    fn, state.invoiceAddressForm)
        }, state),
        feedback: [],
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Pages/OrderDetails/Invoice/InvoiceReducer.ts